import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

interface SSGWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * A warning modal that appears when a user selects the SSG system option
 * to warn about potential dimension discrepancies with DLO measurements.
 */
const SSGWarningModal: React.FC<SSGWarningModalProps> = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            <span>SSG System Warning</span>
          </DialogTitle>
        </DialogHeader>
        
        <div className="bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800 rounded-md p-4 my-2">
          <p className="text-amber-800 dark:text-amber-200">
            Warning: Different SSG systems add different dimensions to DLO. 
            The default here may not be correct for your system.
          </p>
        </div>
        
        <DialogFooter className="mt-4">
          <Button onClick={onClose} className="w-full sm:w-auto">
            Acknowledge
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SSGWarningModal;
